import appStore from '../../../storage/AppStore'
import clubStore from '../../../storage/ClubStore'
import Select from '../../../ui/Select'
import React from 'react'
import {observer} from 'mobx-react-lite'
import Phone from '../../../ui/Phone'
import Btn from '../../../ui/Btn'
import Input from '../../../ui/Input'
import Parent from './Parent'
import Child from './Child'
import systemStore from "../../../storage/SystemStore";
import {useNavigate} from "react-router";

const Member = () => {
  const navigate = useNavigate();
  return (
    <div className="row justify-content-center">
      <h3 className="text-center pb-2 pb-sm-3 mt-lg-3 mt-xl-4">{clubStore.member.id ? appStore.tr.edit : appStore.tr.add_member}</h3>
      <div className="col-md-11 col-lg-9 col-xl-8">
        <div className="tab-content bg-body rounded-5 py-3 py-sm-4 px-4 px-sm-5">
          {/*// <!-- Customers form -->*/}
          <div className="tab-pane fade show active" id="customers" role="tabpanel"
               aria-labelledby="customers-tab">
            <form className={`needs-validation${clubStore.member.was_validated ? ' was-validated' : ''}`} noValidate="">
              <div className="row g-4">
                <div className="col-md-6 position-relative">
                  <label htmlFor="input_title" className="form-label">{appStore.tr.title || 'Аты-жөнү'} *</label>
                  <Input id={'input_title'} store={clubStore.member} prop={'title'}
                         label={appStore.tr.title || 'Аты-жөнү'} required/>
                </div>
                <div className="col-md-6 position-relative">
                  <label htmlFor="input_phone_number" className="form-label">{appStore.tr.phone_number}</label>
                  <Phone
                    id={'input_phone_number'}
                    country={clubStore.club.country_id?.toLowerCase() || 'kg'} // Default country
                    store={clubStore.member}
                    prop={'phone_number'}
                    valid={"is_valid_phone_number"}
                    required={true}
                  />
                </div>
                <div className="col-md-6 position-relative">
                  <label htmlFor="select_club"
                         className="form-label">{appStore.tr.club_branch || 'Клуб/Филиал'} *</label>
                  <Select
                    id={'select_club'}
                    store={clubStore.member}
                    prop={'company_id'}
                    label={appStore.tr.club_branch || 'Клуб/Филиал'}
                    options={clubStore.club.relatives}
                    required
                  />
                </div>
                <div className="col-md-6 position-relative">
                  <label htmlFor="select_role" className="form-label">{appStore.tr.role || 'Роль'} *</label>
                  <Select
                    id={'select_role'}
                    store={clubStore.member}
                    prop={'role_id'}
                    label={appStore.tr.role || 'Роль'}
                    options={appStore.roles}
                    required
                  />
                </div>
                {clubStore.member.role_id === 'MMBR' &&
                  <>
                    <div className='col-md-6 position-relative'>
                      <label htmlFor="input_year_born"
                             className="form-label">{appStore.tr.year_born || 'Туулган жылы'}</label>
                      <Input id={'input_year_born'} type={"number"} store={clubStore.member} prop={'year_born'}
                             label={appStore.tr.year_born || 'Туулган жылы'} required/>
                    </div>
                    <div className='col-md-6 position-relative'>
                      <label htmlFor="input_forma_number"
                             className="form-label">{appStore.tr.forma_number || 'Форма номери'}</label>
                      <Input id={'input_forma_number'} store={clubStore.member} prop={'forma_number'}
                             label={appStore.tr.forma_number || 'Форма номери'} required/>
                    </div>
                    <Parent whois={'mother'} store={clubStore.member.mother} country={clubStore.club.country_id?.toLowerCase()}/>
                    <Parent whois={'father'} store={clubStore.member.father} country={clubStore.club.country_id?.toLowerCase()}/>
                  </>
                }
                {clubStore.member.role_id === 'PRNT' &&
                  <>
                    <div className='col-12'>
                      <div className="form-check form-check-inline">
                        <input
                          type="radio"
                          className="form-check-input"
                          id="ex-radio-5"
                          name="radio-inline"
                          checked={clubStore.member.is_mother}
                          onChange={() => {
                            clubStore.member.setProperty('is_mother', !clubStore.member.is_mother);
                            clubStore.member.setProperty('is_father', !clubStore.member.is_mother);
                          }}
                        />
                          <label htmlFor="ex-radio-5" className="form-check-label">{appStore.tr.mother}</label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          type="radio"
                          className="form-check-input"
                          id="ex-radio-6"
                          name="radio-inline"
                          checked={clubStore.member.is_father}
                          onChange={() => {
                            clubStore.member.setProperty('is_father', !clubStore.member.is_father);
                            clubStore.member.setProperty('is_mother', !clubStore.member.is_father);
                          }}
                        />
                          <label htmlFor="ex-radio-6" className="form-check-label">{appStore.tr.father}</label>
                      </div>
                    </div>
                    {clubStore.member.children.map((child, index) => (
                      <Child key={index} child={child} index={index} country={clubStore.club.country_id?.toLowerCase()} />
                    ))}
                    <div className='col-md-8 position-relative'>
                      &nbsp;
                    </div>
                    <div className='col-md-4 position-relative'>
                      <Btn
                        className="btn btn-secondary btn-sm"
                        onClick={() =>{
                          clubStore.member.add_child()
                        }}>
                        <i className="ci ci-plus"/>&nbsp; {appStore.tr.add_child}
                      </Btn>
                    </div>
                  </>
                }
                <div className="col-12 text-center pt-2 pb-3">
                  <Btn
                      className="btn btn-primary"
                      onClick={() => {
                        clubStore.saveMember()
                            .then(() => {
                              systemStore.setSuccess(appStore.tr.successfully_saved);
                              navigate('/manager/member/list');
                            })
                            .catch((error) => systemStore.setError(appStore.tr[error.message] || error.message))
                      }}>{clubStore.member.id ? appStore.tr.edit : appStore.tr.add_member}</Btn>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default observer(Member);